(function () {
  function optionMatches(optionValue, matchValue) {
    if (!matchValue) return true;
    return (optionValue || '').indexOf(matchValue) !== -1;
  }

  function applyVariant(banner, variant) {
    var shouldShow =
      optionMatches(variant.option1, banner.getAttribute('data-match-option-1')) &&
      optionMatches(variant.option2, banner.getAttribute('data-match-option-2')) &&
      optionMatches(variant.option3, banner.getAttribute('data-match-option-3'));

    banner.style.display = shouldShow ? '' : 'none';

    if (banner.getAttribute('data-hide-shipping') === 'true') {
      var shippingEl = document.querySelector('.skt-dynamic-shipping, .m-product-shipping');
      if (shippingEl) shippingEl.style.display = shouldShow ? 'none' : '';
    }
  }

  function init() {
    var banners = document.querySelectorAll('[data-preorder-banner]');
    if (!banners.length) return;

    document.addEventListener('variant:changed', function (event) {
      var variant = event.detail && event.detail.variant;
      if (!variant) return;
      banners.forEach(function (banner) {
        applyVariant(banner, variant);
      });
    });
  }

  document.readyState === 'loading'
    ? document.addEventListener('DOMContentLoaded', init)
    : init();

  document.addEventListener('shopify:section:load', init);
})();
